@use "variables" as *;

.stack {
  text-align: center;
  padding: $spacing-xs;
}

.username {
  font-size: $fontSize-s;
  font-weight: bold;
  text-align: start;
}

.publicUsernamePrefix {
  font-size: $fontSize-xxs;
  font-weight: normal;
}

.avatar {
  border-width: 2px;
}

.skeletonText {
  width: 60px;
  font-size: $fontSize-s;
}

.skeletonSubtitle {
  width: 60px;
  font-size: $fontSize-xxs;
}

.role {
  text-transform: uppercase;
  font-size: $fontSize-xxs;
  font-weight: lighter;
  text-align: start;
}

.MuiBadge-badge {
  top: 16px !important;
}
